import { Map } from 'immutable'
import { SET_RESOLVER_LOCATION } from '../resolver/actions'
import {
  createRelative,
  isFullPlayer,
  isCart,
  isVideoOrSeries,
  isCourse,
  isShortVideos,
} from '../url/index'
import { setCommentsVisible } from '../comments/actions'
import { selectIsCommentsVisible } from '../comments/selectors'
import { clearUpstreamContext } from '../upstream-context/actions'
import {
  EMAIL_RECOMMENDATION_CLICK_ATTRIBUTION,
  parseRecommIdFromQuery,
} from '../upstream-context/email-recomm-id'
import { URL_HOME, URL_SEARCH } from '../url/constants'
import {
  RESOLVER_TYPE_SUBCATEGORY,
  RESOLVER_TYPE_CLASSIC_FACET,
} from '../resolver/types'

export function pageUnmount ({ after }) {
  return after(SET_RESOLVER_LOCATION, async ({ dispatch }) => {
    dispatch(setCommentsVisible(false))
  }).when(({ state }) => {
    return selectIsCommentsVisible(state)
  })
}

export function watchClearUpstreamContext ({ after }) {
  return after(SET_RESOLVER_LOCATION, async ({ dispatch }) => {
    dispatch(clearUpstreamContext())
  }).when(({ state, prevState }) => {
    const { upstreamContext, resolver } = state
    const { resolver: prevResolver } = prevState

    const path = resolver.get('path') || ''
    const location = resolver.get('location')
    const query = resolver.get('query')
    const prevPath = prevResolver.get('path') || ''

    if (parseRecommIdFromQuery(query) && isVideoOrSeries(path)) {
      return false
    }

    const emailClickAttribution = upstreamContext.getIn(['data', 'playEventData', 'clickAttribution'])
    if (
      emailClickAttribution === EMAIL_RECOMMENDATION_CLICK_ATTRIBUTION
      && createRelative(prevPath) === createRelative(path)
    ) {
      return false
    }

    const prevUtmSource = prevResolver.getIn(['query', 'utm_source'])
    const mhTileData = upstreamContext.getIn(['data', 'mhTileData'])
    const playEventData = upstreamContext.getIn(['data', 'playEventData'])
    const sharePageAttribution = upstreamContext.getIn(['data', 'sharePageAttribution'])

    const hasMhTileData = Map.isMap(mhTileData) && mhTileData.size > 0
    const hasPlayEventData = Map.isMap(playEventData) && playEventData.size > 0
    const hasCheckoutEventsData = Map.isMap(sharePageAttribution) && sharePageAttribution.size > 0

    const prevDetailPage = isVideoOrSeries(prevPath) || isCourse(prevPath)
    const prevHomePage = createRelative(prevPath) === createRelative(URL_HOME)
    const prevSearchPage = createRelative(prevPath) === createRelative(URL_SEARCH)
    const prevResolverType = prevResolver.getIn(['data', 'type'])
    const prevResolverId = prevResolver.getIn(['data', 'id'], -1)
    const prevVocabulary = prevResolver.getIn(['data', 'vocabulary'])
    // Brooklyn pathinfo maps some term bundles (e.g. genres) to type: null, which the
    // web app resolves as notFound. Those responses still include id + vocabulary, so
    // treat a positive term id with vocabulary as a subcategory/topic page.
    const prevSubcategoryPage = prevResolverType === RESOLVER_TYPE_SUBCATEGORY
      || prevResolverType === RESOLVER_TYPE_CLASSIC_FACET
      || (prevResolverId > 0 && Boolean(prevVocabulary))
    const prevPage = prevHomePage || prevSearchPage || prevSubcategoryPage
    const prevSharePage = prevUtmSource === 'share' && hasCheckoutEventsData
    const isDetailPage = (isVideoOrSeries(path) || isCourse(path) || isShortVideos(path))
      && (hasMhTileData || hasPlayEventData)
    const isPlayer = isFullPlayer(location.query || {}) && hasPlayEventData
    const isCheckout = isCart(path) && hasCheckoutEventsData

    // Don't clear upstream context if we are on the checkout flow
    // and we started in the share page
    if (isCheckout || prevSharePage) {
      return false
    }

    // Don't clear upstream context if we are redirecting to the VideoPlayer
    // or to a DetailPage from MemberHome, Search, subcategory, or classic-facet
    if ((prevPage && isPlayer)
      || (prevPage && isDetailPage)
      || (prevDetailPage && isPlayer)) {
      return false
    }

    return true
  })
}
